(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-casino/assets/javascripts/info-page.js') >= 0) return;  svs.modules.push('/modules/lb-casino/assets/javascripts/info-page.js');
"use strict";


class InitInfoPage {
  constructor() {
    var _svs$lb_casino$data$r;
    new svs.components.casino.InfoPage(document.getElementById('info-page'), (_svs$lb_casino$data$r = svs.lb_casino.data.renderModel) === null || _svs$lb_casino$data$r === void 0 ? void 0 : _svs$lb_casino$data$r.currentGame);
  }
}
setGlobal('svs.lb_casino.initInfoPage', () => new InitInfoPage());

 })(window);